import * as z from "zod";

/** Called by the app's server: revokes a key it was issued, and no other. */
export const revokeTeamAccessKey = {
  name: "revokeTeamAccessKey" as const,
  input: z.object({
    client_id: z.string(),
    client_secret: z.string(),
    token: z.string(),
  }),
  output: z.object({ revoked: z.boolean() }),
};
